import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store';
import { removeNotification } from '../../../store/slices/uiSlice';
import './GlobalToast.css';

const GlobalToast: React.FC = () => {
  const notifications = useSelector((state: RootState) => state.ui.notifications);
  const dispatch = useDispatch();

  useEffect(() => {
    notifications.forEach((notification: any) => {
      if (notification.duration !== 0) {
        const timer = setTimeout(() => {
          dispatch(removeNotification(notification.id));
        }, notification.duration || 3000);
        return () => clearTimeout(timer);
      }
    });
  }, [notifications, dispatch]);

  if (notifications.length === 0) return null;

  return (
    <div className="global-toast-container">
      {notifications.map((toast: any) => (
        <div key={toast.id} className={`global-toast-message toast-${toast.type}`}>
          <div className="toast-content">
            {toast.title && <strong className="toast-title">{toast.title}</strong>}
            <span className="toast-text">{toast.message}</span>
          </div>
          <button className="toast-close-btn" onClick={() => dispatch(removeNotification(toast.id))}>&times;</button>
        </div>
      ))}
    </div>
  );
};

export default GlobalToast;
